export default __webpack_public_path__ + "static/media/table.9ee880fc.jpg";